{
  "el": {
    "form": {
      "actions": {
        "cancel": "Ακύρωση",
        "clear": "Εκκαθάριση",
        "closeFullPage": "Κλείσιμο πλήρους σελίδας",
        "copyText": "Κάνε κλικ για αντιγραφή του κειμένου",
        "create_and_send_to_customer": "Δημιουργία και αποστολή στον πελάτη",
        "create_and_share": "Δημιουργία και κοινοποίηση στον πελάτη",
        "create_and_share_partners_only": "Δημιουργία και κοινοποίηση στους συνεργάτες",
        "create_and_share_with_partners": "Δημιουργία και κοινοποίηση σε πελάτη και συνεργάτες",
        "next": "Επόμενο",
        "only_create": "Μόνο δημιουργία",
        "openFullPage": "Άνοιγμα σε πλήρη σελίδα",
        "save": "Αποθήκευση",
        "saveChanges": "Αποθήκευση αλλαγών",
        "search": "Αναζήτηση...",
        "send": "Αποστολή",
        "send_and_create_another": "Αποστολή και δημιουργία νέου",
        "send_to_customer": "Αποστολή στον πελάτη",
        "share_with_customer": "Κοινοποίηση στον πελάτη",
        "submit": "Υποβολή",
        "submit_and_create_another": "Υποβολή και δημιουργία νέου"
      },
      "back": "Προηγούμενο βήμα",
      "labels": {
        "columns": "Στήλες",
        "from": "Από",
        "no_results": "Κανένα αποτέλεσμα",
        "to": "Έως"
      },
      "notifications": {
        "textHasBeenCopied": "Το κείμενο αντιγράφηκε"
      },
      "password": "Κωδικός πρόσβασης",
      "shortcuts": {
        "save_mac": "⌘ + Enter για αποθήκευση",
        "save_windows": "Ctrl + Enter για αποθήκευση",
        "send_mac": "⌘ + Enter για αποστολή",
        "send_windows": "Ctrl + Enter για αποστολή"
      },
      "steps": "Βήμα {count} από {total}",
      "writeEmployeeNameReject": "Γράψε <i><b>{employeeName}</b></i> για να συνεχίσεις."
    }
  }
}
